import Image from "next/image";
import { PureComponent } from "react";
import "./stepper-progress.scss";
class StepperProgress extends PureComponent {
  render() {
    const { currentStep } = this.props;
    const steps = [
      "Name & Email",
      "Email Validation",
      "Profile Details",
      "Upgrade (optional)",
    ];
    return (
      <div className="progress-bar">
        {steps.map((step, index) => {
          let className = "step";
          if (index + 1 < currentStep) {
            className += " completed";
          } else if (index + 1 === currentStep) {
            className += " active";
          }

          return (
            <>
              <div key={index} className={`${className} slider__button`}>
                <div className="circle__progress__div">
                  <div className="progressbar__dot"></div>
                  <div className="complete__check">
                    <Image
                      src="/static/images/tickStepper.svg"
                      alt="Find a co-founder today"
                      height={10}
                      width={10}
                      priority={true}
                    />
                  </div>
                </div>
                <p> {step}</p>
              </div>
            </>
          );
        })}
      </div>
    );
  }
}

export default StepperProgress;
